// extracted by mini-css-extract-plugin
module.exports = {"item":"BoxItemWithLink_item__2muHL"};